export default "__VITE_ASSET__CTP3W_TR__"